module.exports = __webpack_public_path__ + "static/media/icon_08.c56728ba.png";